import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Badge3rdParty = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M9.56 3.435 8 2 6.44 3.435l-2.148-.29-.375 2.034L2 6.146 2.953 8 2 9.854l1.917.967.375 2.033 2.148-.289L8 14l1.56-1.435 2.148.29.375-2.034L14 9.854 13.047 8 14 6.146l-1.917-.967-.375-2.033-2.148.289Z"
      fill="#4F9BDE"
      fillRule="evenodd"
    />
    <path d="m5.346 7.876.892-.849L7.37 8.103 9.632 5.95l.892.849-3.155 3-2.023-1.924Z" fill="#fff" />
  </Icon>
));

export default Badge3rdParty;
